import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../../../context/MyContext";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { baseUrl, setAuthToken, setIsLoggedIn, setLoggedInCustomer } =
    useContext(MyContext);
  const navigate = useNavigate();

  // ── login ke baad pending cart/wishlist action complete karo — kmcustomer_id nahi bhejte, backend auth token se nikalta hai ──
  const runPendingAction = (token) => {
    const pending = localStorage.getItem("pendingAction");

    if (!pending) {
      navigate("/");
      return;
    }

    const { type, product, quantity, returnPath } = JSON.parse(pending);
    localStorage.removeItem("pendingAction");

    if (type === "cart") {
      const formData = new FormData();
      formData.append("kmproduct_id", product.id);
      formData.append("amountPerPiece", product.price);
      formData.append("quantity", quantity);
      formData.append("total_price", product.price * quantity);

      axios
        .post(`${baseUrl}/customer/cart/addProductToCart`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          navigate(returnPath || "/");
        })
        .catch((error) => {
          console.log("pending cart action error:", error);
          navigate(returnPath || "/");
        });
    } else if (type === "wishlist") {
      const formData = new FormData();
      formData.append("kmproduct_id", product.id);

      axios
        .post(`${baseUrl}/customer/wishlist/toggleWishlist`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          navigate(returnPath || "/");
        })
        .catch((error) => {
          console.log("pending wishlist action error:", error);
          navigate(returnPath || "/");
        });
    } else {
      navigate(returnPath || "/");
    }
  };

  const autoLogin = (savedEmail, savedPassword) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("email", savedEmail);
    formdata.append("password", savedPassword);

    axios
      .post(`${baseUrl}/customer/auth/login`, formdata)
      .then((response) => {
        if (!response.data.token) {
          setLoading(false);
          localStorage.removeItem("userEmail");
          localStorage.removeItem("userPassword");
        } else {
          setLoading(false);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          setLoggedInCustomer(response.data.customer);
          setIsLoggedIn(true);
          runPendingAction(response.data.token);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userPassword");
      });
  };

  const loginCustomer = () => {
    setLoading(true);
    setErrorMessage("");
    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/customer/auth/login`, formdata)
      .then((response) => {
        if (!response.data.token) {
          setErrorMessage(
            response.data.message || response.data.error || "Invalid email or password"
          );
          setLoading(false);
        } else {
          setLoading(false);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          setIsLoggedIn(true);
          localStorage.setItem("userEmail", email);
          localStorage.setItem("userPassword", password);
          localStorage.setItem(
            "loggedInCustomer",
            JSON.stringify(response.data.customer),
          );
          setLoggedInCustomer(response.data.customer);
          runPendingAction(response.data.token);
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage(
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Login failed. Please check your credentials."
        );
        setLoading(false);
      });
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("userEmail");
    const savedPassword = localStorage.getItem("userPassword");
    if (savedEmail != null && savedEmail != "") {
      autoLogin(savedEmail, savedPassword);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div className="minimal-auth-wrapper">
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Spinner
            animation="border"
            role="status"
            style={{ width: "4rem", height: "4rem", color: "#097d43" }}
          />
          <p
            style={{
              marginTop: "15px",
              fontSize: "18px",
              color: "#097d43",
              fontWeight: 600,
            }}
          >
            Login you ...
          </p>
        </div>
      ) : (
        <>
          <div className="doodle-background">
            <div className="doodle-pattern"></div>
          </div>

          <div className="minimal-auth-container">
            <div className="minimal-auth-card">
              <div className="auth-header">
                <h1 className="auth-title">Welcome back!</h1>
                <p className="auth-subtitle">
                  Don't have an account?{" "}
                  <Link to="/customer/register" className="auth-link">
                    Register
                  </Link>
                </p>
              </div>

              <Form className="minimal-auth-form">
                <div className="authform-group-minimal">
                  <Form.Control
                    type="email"
                    placeholder="Work email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    className="minimal-input"
                    required
                  />
                </div>

                <div className="authform-group-minimal">
                  <div className="password-input-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                      className="minimal-input"
                      required
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div className="text-end mb-2">
                  <Link to="/customer/forgot-password" className="auth-link">
                    Forgot password?
                  </Link>
                </div>

                {errorMessage && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "0.875rem",
                      marginBottom: "1rem",
                      padding: "0.75rem",
                      background: "#fff3f3",
                      borderRadius: "8px",
                      border: "1px solid #ffdddd",
                    }}
                  >
                    {errorMessage}
                  </div>
                )}

                <Button
                  type="button"
                  className="minimal-submit-btn"
                  onClick={() => loginCustomer()}
                  disabled={loading}
                >
                  Log In
                </Button>
              </Form>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Login;
